import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Periodically re-renders the page via Turbo so a long-lived dashboard tab
// stays current without a manual reload.
export default class extends Controller {
  static values = { interval: { type: Number, default: 60000 } }

  connect() {
    this.timeout = setTimeout(() => this.refresh(), this.intervalValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  refresh() {
    Turbo.visit(window.location.href, { action: "replace" })
  }
}
